import { Td } from '../../../../components/PdfExportV2/Td/Td.tsx';
import { Text } from '../../../../components/PdfExportV2/Text/Text.tsx';
import { Tr } from '../../../../components/PdfExportV2/Tr/Tr.tsx';
import { BORDER } from '../consts.ts';
import { textStyleOverrides } from './consts.ts';
import { makeColSpan } from './utils/makeColSpan.ts';

export const ExportCostApproachRollupRow = ({
  label,
  value,
  isFirstRow,
  isBold,
  showEquals = true,
}: {
  label: string;
  value: string;
  isFirstRow?: boolean;
  isBold?: boolean;
  showEquals?: boolean;
}) => (
  <Tr>
    <Td
      style={{
        width: makeColSpan(0, 1),
        borderLeft: BORDER,
        borderTop: isFirstRow ? BORDER : undefined,
      }}
    >
      <Text variant="body1" {...textStyleOverrides} fontWeight={isBold ? 'bold' : undefined}>
        {label}
      </Text>
    </Td>
    <Td
      style={{
        width: makeColSpan(1, 7),
        textAlign: 'right',
        borderTop: isFirstRow ? BORDER : undefined,
      }}
    >
      <Text variant="body1" {...textStyleOverrides} fontWeight={isBold ? 'bold' : undefined}>
        {value ? `${showEquals ? '= ' : ''}${value}` : ''}
      </Text>
    </Td>
  </Tr>
);
